// AdminTransactions Component - Transactions list
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { History } from 'lucide-react';
import { formatTransactionAmount } from '../../utils/currency';
import { useAdmin } from './AdminContext';

export default function AdminTransactions({ transactions: propTransactions }) {
  const adminContext = useAdmin();
  // Use props if provided, otherwise fallback to context
  const transactions = propTransactions || adminContext?.transactions || [];
  const formatDate = adminContext?.formatDate || ((d) => d ? new Date(d).toLocaleDateString() : 'N/A');
  const language = adminContext?.language || 'fr';

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-3">
          <div className="h-10 w-10 rounded-xl bg-gradient-to-br from-purple-500 to-purple-600 flex items-center justify-center shadow-lg">
            <History className="h-5 w-5 text-white" />
          </div>
          {language === 'fr' ? 'Toutes les Transactions' : 'All Transactions'}
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-2">
          {transactions.length === 0 ? (
            <div className="text-center py-8 text-muted-foreground">
              {language === 'fr' ? 'Aucune transaction pour le moment' : 'No transactions yet'}
            </div>
          ) : (
            transactions.map((tx) => (
              <div 
                key={tx.transaction_id} 
                className="flex items-center justify-between p-4 rounded-xl border border-border"
              >
                <div>
                  <p className="font-medium">{tx.description}</p>
                  <p className="text-sm text-muted-foreground">
                    {tx.type} • {tx.reference || 'N/A'} • {formatDate(tx.created_at)}
                  </p>
                </div>
                <div className="text-right">
                  <p className={`font-bold text-lg ${
                    ['topup', 'transfer_in', 'refund', 'admin_adjustment'].includes(tx.type) && tx.amount > 0 
                      ? 'text-green-600' 
                      : 'text-red-500'
                  }`}>
                    {formatTransactionAmount(tx.amount, tx.amount > 0)}
                  </p>
                  <span className={`text-xs px-2 py-0.5 rounded-full ${
                    tx.status === 'completed' 
                      ? 'bg-green-100 text-green-700' 
                      : 'bg-yellow-100 text-yellow-700'
                  }`}>
                    {tx.status}
                  </span>
                </div>
              </div>
            ))
          )}
        </div>
      </CardContent>
    </Card>
  );
}
